<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
          <timeline v-if="testimony" ref="timeline" :id="testimony._id" :testimony="testimony"/>
      </div>
  </section>
</template>

<script>

import api from '../../api'
import config from '../../config'
import moment from 'moment'
import async from 'async'

export default {
  name: 'TestimonyHistory',
  data () {
    return {
      id: this.$route.params.id,
      file: null,
      similars: [],
      testimony: null,
      editMode: false,
      cases: [],
      uploadEndPoint: null,
      anchors: [],
      caseToDetach: null
    }
  },
  methods: {
    refresh (obj) {
      this.testimony = obj.response
      this.$refs.timeline.getHistory()
    },
    getStartTime () {
      if (this.testimony && this.testimony.actionPeriod) {
        const hour = 12
        return moment(this.testimony.actionPeriod.startDate).hour(hour)
      }
    },
    getUrl (file) {
      return `${config.serverURI}/testimonies/${this.id}/attachments/${file}?token=${window.localStorage.getItem('token').substring(7)}`
    },
    getToken () {
      return { 'Authorization': window.localStorage.getItem('token') }
    },
    getUploadEndpoint () {
      return `${config.serverURI}/testimonies/${this.id}/${this.testimony.version}/attachments`
    },
    confirm () {
      window.jQuery('#ConfirmModal').modal({})
    },
    confirmDeleteFile (file) {
      this.file = file
      window.jQuery('#ConfirmDeleteFileModal').modal({})
    },
    confirmRemoveLink (caseId) {
      this.caseToDetach = caseId
      window.jQuery('#ConfirmLinkModal').modal({})
    },
    removeLink () {
      const body = {
        testimonyId: this.id,
        version: this.testimony.version
      }
      return api.authenticatedRequest('delete', `/cases/${this.caseToDetach}/testimonies`, body)
        .then(response => {
          this.getTestimony()
          this.$refs.timeline.getHistory()
          this.getRelatedCases()
        })
        .catch(error => {
          console.log(error)
        })
    },
    openLinkModal () {
      this.$refs.linkCaseModal.removeLinkedCases()
      window.jQuery('#LinkCaseModal').modal({})
    },
    linkAll (selectedCases) {
      console.log('about to add selected Cases : ')
      console.log(selectedCases)
      async.eachOfSeries(selectedCases, this.link, (err) => {
        if (err) console.log(err)
        this.getTestimony()
        this.$refs.timeline.getHistory()
        this.getRelatedCases()
      })
    },
    link (selectedCase, index, callback) {
      console.log(selectedCase)
      const body = {
        testimonyId: this.id,
        version: this.testimony.version + index
      }
      console.log(body)
      return api.authenticatedRequest('post', `/cases/${selectedCase._id}/testimonies`, body)
        .then(response => {
          callback()
        })
        .catch(error => {
          console.log(error)
          callback(error)
        })
    },
    getSimilars () {
      api.authenticatedRequest('get', `/testimonies/${this.id}/similar`)
      .then(response => {
        this.similars = response.data.data
      })
      .catch(error => {
        console.log(error)
        if (error.response.status === 401) { // InvalidCredentialsError
          this.response = 'Username/Password incorrect. Please try again.'
          return
        }
        this.response = 'Server appears to be offline'
      })
    },
    getRelatedCases () {
      api.authenticatedRequest('get', `/testimonies/${this.id}/cases`)
      .then(response => {
        this.cases = response.data.data
      })
      .catch(error => {
        console.log(error)
      })
    },
    deleteFile () {
      api.authenticatedRequest('delete', `/testimonies/${this.id}/${this.testimony.version}/attachments/${this.file}`)
      .then(response => {
        this.testimony = response.data
        this.$refs.timeline.getHistory()
      })
      .catch(error => {
        console.log(error)
        this.goToReadMode()
        if (error.response.status === 401) { // InvalidCredentialsError
          this.response = 'Username/Password incorrect. Please try again.'
          return
        }
        this.response = 'Server appears to be offline'
      })
    },
    archive () {
      api.authenticatedRequest('delete', `/testimonies/${this.id}?version=${this.testimony.version}`)
      .then(response => {
        this.$router.push({name: 'Testimonies'})
      })
      .catch(error => {
        console.log(error)
        this.goToReadMode()
        if (error.response.status === 401) { // InvalidCredentialsError
          this.response = 'Username/Password incorrect. Please try again.'
          return
        }
        this.response = 'Server appears to be offline'
      })
    },
    anchor () {
      api.authenticatedRequest('post', `/testimonies/${this.id}/anchor/${this.testimony.version}`)
      .then(response => {
        this.testimony = response.data.testimony
        this.getAnchors()
        this.$refs.timeline.getHistory()
      })
      .catch(error => {
        console.log(error)
        this.goToReadMode()
        if (error.response.status === 401) { // InvalidCredentialsError
          this.response = 'Username/Password incorrect. Please try again.'
          return
        }
        this.response = 'Server appears to be offline'
      })
    },
    goToEditMode () {
      this.editMode = true
    },
    goToReadMode () {
      this.editMode = false
    },
    save () {
      api.authenticatedRequest('post', `/testimonies/${this.id}/comment`, { comment: this.testimony.comment, version: this.testimony.version })
      .then(response => {
        this.editMode = false
        this.testimony = response.data
        this.$refs.timeline.getHistory()
      })
      .catch(error => {
        console.log(error)
        this.goToReadMode()
        if (error.response.status === 401) { // InvalidCredentialsError
          this.response = 'Username/Password incorrect. Please try again.'
          return
        }
        this.response = 'Server appears to be offline'
      })
    },
    getTestimony () {
      api.authenticatedRequest('get', `/testimonies/${this.id}`)
      .then(response => {
        this.testimony = response.data
      })
      .catch(error => {
        console.log(error)
        if (error.response.status === 401) { // InvalidCredentialsError
          this.response = 'Username/Password incorrect. Please try again.'
          return
        }
        this.response = 'Server appears to be offline'
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getTestimony()
      this.getRelatedCases()
      this.getSimilars()
    })
  }
}
</script>
<style>

  .file-name {
    margin-left: 30px;
  }

  .clickable {
      cursor: pointer;
  }

  .vuejs-uploader label {
    margin-bottom: 20px;
}

  .identity, .details {
    font-size: 15px;
  }

  .subtitle {
    padding-left: 20px;
  }

  .add-data-testimony {
    margin: 0 -10px;
    margin-top: 10px;
    padding-bottom: 0;
  }

  .add-data-testimony button:active:focus {
    outline: none;
  }

  .vuejs-uploader label {
    line-height: 40px;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// TestimonyHistory.vue?03bf606f